module.exports = __webpack_public_path__ + "img/party_mask.498ac6cc.svg";